import Breadcrumb from "@/components/base/Breadcrumb";
import { useSeo } from "@/hooks/useSeo";

const values = [
  { title: "资讯及时", desc: "紧跟上映动态与行业脉搏，第一时间为你带来值得关注的电影资讯。", icon: "ri-newspaper-line" },
  { title: "推荐真诚", desc: "拒绝无脑安利，每一部推荐影片都经过口碑与评分的双重筛选。", icon: "ri-heart-3-line" },
  { title: "内容有深度", desc: "不止于简介，我们更愿意和你分享对影片的思考与观点。", icon: "ri-chat-quote-line" },
  { title: "体验清爽", desc: "清晰的分类与多维筛选，让你更快找到想看的那一部。", icon: "ri-layout-grid-line" },
];

const notices = [
  "本站所有影片信息、评分、影评及资讯均为虚构示范内容，仅用于演示，不代表任何真实影视作品。",
  "本站为纯前端演示站点，不提供登录、注册、支付及后台管理功能，收藏数据仅保存在你的浏览器本地。",
  "分享功能为前端演示，未接入任何第三方分享接口，不会真实发布任何内容。",
  "站内展示的图片均为示意图，版权归其各自权利人所有，仅用于页面演示。",
];

export default function AboutPage() {
  useSeo({
    title: "关于我们 - 91电影",
    description:
      "了解91电影的网站定位、发展理念、联系方式与用户须知。91电影致力于成为便捷全面、富有深度的电影内容平台。",
    keywords: "关于91电影,网站介绍,联系方式,用户须知,版权声明",
  });

  return (
    <div className="w-full px-4 md:px-8 py-8 animate-fade-up">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

      <section className="mt-6 bg-primary-700 rounded-lg overflow-hidden">
        <div className="px-6 md:px-12 py-12 md:py-16">
          <span className="inline-flex items-center gap-1 bg-accent-500 text-secondary-950 text-xs font-bold rounded-md px-3 py-1 mb-5">
            <i className="ri-film-line" />
            关于 91电影
          </span>
          <h1 className="font-heading font-extrabold text-3xl md:text-4xl text-background-50 leading-snug max-w-3xl">
            一个便捷全面、富有深度的电影内容平台
          </h1>
          <p className="text-background-200/90 text-sm md:text-base mt-5 max-w-3xl leading-relaxed">
            91电影是一家专业的电影资讯与影片推荐平台，主要面向广大电影爱好者与普通观影用户。
            我们帮助他们获取最新上映电影资讯、精选影片推荐及影评分析，解决用户了解影片信息、筛选观影内容的核心需求。
          </p>
        </div>
      </section>

      <section className="mt-14">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-1.5 h-6 rounded-full bg-accent-500" />
          <h2 className="font-heading font-bold text-2xl text-foreground-950">网站定位与发展</h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="flex flex-col gap-5 text-base leading-[1.9] text-foreground-800">
            <p>
              网站内容涵盖国内外最新电影报道、影片简介、观影指南和经典影片介绍。
              我们希望通过清晰的分类体系与多维筛选工具，让每一位用户都能轻松找到自己感兴趣的内容。
            </p>
            <p>
              从创立之初，91电影就坚持一个朴素的理念：好的推荐，应该建立在真实的口碑与深入的了解之上。
              因此我们不仅提供影片的基础信息，也持续产出有观点、有温度的影评与专题策划。
            </p>
            <p>
              未来，我们将继续完善内容体系，拓展更多类型的观影指南与专题影单，
              陪伴每一位热爱电影的你，走过更多值得回味的观影时光。
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {values.map((v) => (
              <div key={v.title} className="bg-background-50 rounded-lg border border-background-200 p-5">
                <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center mb-3">
                  <i className={`${v.icon} text-xl`} />
                </span>
                <h3 className="font-heading font-bold text-base text-foreground-950">{v.title}</h3>
                <p className="text-sm text-foreground-500 mt-2 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mt-14">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-1.5 h-6 rounded-full bg-accent-500" />
          <h2 className="font-heading font-bold text-2xl text-foreground-950">联系方式与反馈</h2>
        </div>
        <div className="bg-background-50 rounded-lg border border-background-200 p-6 md:p-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="flex items-start gap-4">
            <span className="w-11 h-11 shrink-0 rounded-md bg-primary-50 text-primary-700 flex items-center justify-center">
              <i className="ri-mail-line text-xl" />
            </span>
            <div>
              <p className="font-heading font-bold text-sm text-foreground-950">内容合作</p>
              <p className="text-sm text-foreground-500 mt-1">demo@91movie.example</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <span className="w-11 h-11 shrink-0 rounded-md bg-primary-50 text-primary-700 flex items-center justify-center">
              <i className="ri-feedback-line text-xl" />
            </span>
            <div>
              <p className="font-heading font-bold text-sm text-foreground-950">意见反馈</p>
              <p className="text-sm text-foreground-500 mt-1">support@91movie.example</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <span className="w-11 h-11 shrink-0 rounded-md bg-primary-50 text-primary-700 flex items-center justify-center">
              <i className="ri-map-pin-line text-xl" />
            </span>
            <div>
              <p className="font-heading font-bold text-sm text-foreground-950">办公地址</p>
              <p className="text-sm text-foreground-500 mt-1">某某市某某区某某路 88 号（示范地址）</p>
            </div>
          </div>
        </div>
        <p className="text-xs text-foreground-400 mt-3">
          * 以上联系方式与地址均为演示用示范信息，无真实联系渠道。
        </p>
      </section>

      <section className="mt-14">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-1.5 h-6 rounded-full bg-accent-500" />
          <h2 className="font-heading font-bold text-2xl text-foreground-950">用户须知与版权声明</h2>
        </div>
        <div className="bg-secondary-100 rounded-lg border border-background-200 p-6 md:p-8">
          <ul className="flex flex-col gap-4">
            {notices.map((text, idx) => (
              <li key={idx} className="flex items-start gap-3">
                <span className="w-6 h-6 shrink-0 rounded-full bg-primary-500 text-background-50 text-xs font-bold flex items-center justify-center mt-0.5">
                  {idx + 1}
                </span>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{text}</p>
              </li>
            ))}
          </ul>
          <p className="text-sm text-foreground-500 mt-6 pt-5 border-t border-background-300">
            © 2025 91电影 · 本站为演示站点，所有内容均为虚构示范信息。
          </p>
        </div>
      </section>
    </div>
  );
}